import { IConfig } from '@/interface/game';
import CatcherGameContent from './Catcher/CatcherGameContent';
import { gameTypes } from '@/constants/game';
import QuestGameContent from './Quest/QuestGameContent';
import RiseBurstGameContent from './RiseBurst/RiseBurstGameContent';
type ARCategoryGameContentProps = {
  config?: IConfig;
  type: string;
};
const ARCategoryGameContent = ({
  config,
  type,
}: ARCategoryGameContentProps) => {
  const renderGame = () => {
    switch (type) {
      case gameTypes.CATCHER:
        return <CatcherGameContent config={config} />;
      case gameTypes.QUEST:
        return <QuestGameContent config={config} />;
      case gameTypes.RISE_BURST:
        return <RiseBurstGameContent config={config} />;
    }
  };
  return <>{renderGame()}</>;
};

export default ARCategoryGameContent;
